<img [src]="dataURL">
